export const MerchantSelectionFormMessages = {
  merchantNamePlaceholder: {
    id: 'Pages.MerchantSelection.Form.merchantNamePlaceholder',
    description: 'Merchant Name',
  },
}
